import { columnsDataComplex } from "./variables/columnsData";
import { useAuth } from "context/AuthProvider";
import { useEffect, useState } from "react"; // Import useEffect and useState
import { Segmented } from "antd";
import Card from "components/card";
import Radio from "components/radio";
import Switch from "components/switch";
import Dropdown from "components/dropdown";
import { MdArrowDropDown } from "react-icons/md";
import { BsChatDots } from "react-icons/bs";
import { BsX } from "react-icons/bs";
import { BsPerson } from "react-icons/bs";
import { AiOutlineSend } from "react-icons/ai";
import { useRef } from "react";
import ChatbotWidget from "components/ChatbotWidget";
import Info from "./components/Info";
import { FRONTEND_URL } from "helpers/constants";
import Request from "helpers/request";
import { urls } from "helpers/urls";

const ChatWidget = ({ id, name, color}) => {

  useEffect(() => {
    if (!id) return;

    const createChatSession = async () => {
      try {
        const res = await Request.postJson(urls.createChatSession, { site_id: id });

        const sessionId = res?.data?.data?.session_id;
        if (sessionId) {
  
          // Step 1: Get existing object from localStorage
          const existingSessions = JSON.parse(localStorage.getItem("chat_session_id")) || {};

          // Step 2: Update or add the new site_id: session_id pair
          existingSessions[id] = sessionId;

          // Step 3: Save back to localStorage
          localStorage.setItem("chat_session_id", JSON.stringify(existingSessions));

          // console.log("Updated session object:", existingSessions);
        } else {
          // console.warn("No session_id in response.");
        }
      } catch (err) {
        console.error("Failed to create chat session:", err);
      }
    };

    createChatSession();
  }, [id]);
  
  const [copied, setCopied] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [widgetPosition, setWidgetPosition] = useState("bottom-right");
  const messagesEndRef = useRef(null);
  const [activeSegment, setActiveSegment] = useState("Appearance");

  // Scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  const { currentSub, plan } = useAuth();
  const [currentSubWithPlanName, setCurrentSubWithPlanName] = useState([]);

  useEffect(() => {
    const planIdToPlanData = {};
    plan.forEach((planItem) => {
      planIdToPlanData[planItem.id] = planItem;
    });

    const updatedCurrentSub = currentSub.map((subscription) => {
      const matchingPlan = planIdToPlanData[subscription.plan_id] || null;

      return {
        ...subscription,
        plan_name: matchingPlan ? matchingPlan.plan_name : "N/A",
      };
    });

    setCurrentSubWithPlanName(updatedCurrentSub);
  }, [currentSub, plan]);

  const widgetCode = `<!-- Start Smart Roots Chatbot Widget -->
  <script src="${FRONTEND_URL}widget.js" data-site-id= "${id}"></script>
  <!-- End Smart Roots Chatbot Widget -->`;

  console.log("widgetPosition",widgetPosition)

  const items = [
    {
      key: "1",
      label: "Appearance",
      children: (
        <Card
          extra={
            "w-full h-full p-0 sm:overflow-x-auto rounded-none rounded-b-md rounded-tr-md"
          }
        >
          <Info id={id} widgetName={name} widgetCode={widgetCode} copied={copied} setCopied={setCopied} isActive={isActive} setIsActive={setIsActive} widgetPosition={widgetPosition} setWidgetPosition={setWidgetPosition} />
        </Card>
      ),
    },
    {
      key: "2",
      label: "Behavior",
      children: (
        <Card
          extra={
            "w-full h-full p-4 sm:overflow-x-auto rounded-none rounded-b-md rounded-tr-md"
          }
        >
          <div className="  overflow-x-scroll xl:overflow-hidden">
            <div>
              <h4 className="mb-2 block text-base font-semibold">
                On Click Behavior
              </h4>
              <div>
                <Dropdown
                  button={
                    <div className="flex w-full cursor-pointer items-center gap-2 rounded-md border bg-white px-2 py-[3px] dark:!border-white/10">
                      Maximize
                      <MdArrowDropDown className="h-4 w-4 text-gray-600 dark:text-white" />
                    </div>
                  }
                  children={
                    <ul className="flex max-h-[180px] w-[120px] flex-col gap-2 overflow-y-scroll rounded-[10px] bg-white p-2 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
                      <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                        Maximize
                      </li>
                      <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                        Popout
                      </li>
                      <li className="linear flex cursor-pointer items-center justify-start rounded-md px-2 py-[8px] text-sm font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10">
                        Slide
                      </li>
                    </ul>
                  }
                  classNames={"py-2 top-8 -left-[8px] md:-left-[8px] w-max"}
                  animation="origin-top transition-all duration-300 ease-in-out"
                ></Dropdown>
              </div>
            </div>
          </div>
        </Card>
      ),
    },
  ];

  const segmentOptions = items.map((i) => i.label);

  return (
    <div>
      <div className="inner-source-tabs-wrap">
        <Segmented options={segmentOptions} value={activeSegment} onChange={setActiveSegment} size="large"/>
        <div className="mt-4">
          {items.find((i) => i.label === activeSegment)?.children}
        </div>
      </div>
    </div>
  );
};

export default ChatWidget;
